import {useAuth0} from '@auth0/auth0-react';

export interface OrgDetails {
  id: string;
  name: string;
  displayName?: string | null;
  logoUrl?: string | null;
}

export interface UserDetails {
  user: ReturnType<typeof useAuth0>['user'];
  isLoading: boolean;
  org: OrgDetails | undefined;
  roles: string[];
  nickname: string | undefined;
  email: string | undefined;
  picture: string | undefined;
  name: string | undefined;
}

export function useUserDetails(claimsNamespace: string): UserDetails {
  const {user, isLoading} = useAuth0();

  const orgClaimKey = `${claimsNamespace}/org`;
  const rolesClaimKey = `${claimsNamespace}/roles`;

  const org = user?.[orgClaimKey] as OrgDetails | undefined;
  const roles = (user?.[rolesClaimKey] as string[]) || [];

  return {
    user,
    isLoading,
    org,
    roles,
    nickname: user?.nickname,
    email: user?.email,
    picture: user?.picture,
    name: user?.name
  };
}
